'use strict';

module.exports = {
    createSelectors: function(map) {
        var view = this;
        if (Odigeo._.isEmpty(view.selectors)) {
            view.selectors = Odigeo._.reduce(Odigeo._.keys(view.templateSelectors), function(selectors, key) {
                selectors[key] = Odigeo.Utils.templateLiteral(view.templateSelectors[key], map);
                return selectors;
            }, {});
        }
    },
    selectors: {},
    getCachedSelector: function(alias) {
        var locator = this.selectors[alias] || alias;
        var $el = this.$cachedSelectors[locator];
        if (!$el) {
            $el = this.$el.find(locator);
            this.addSelectorToCache(locator, $el);
        }
        return $el;
    },
    templateSelectors: {},
};
